<router-outlet></router-outlet>
<div class="lazy-loading-container" *ngIf="lazyLoading === true">
    <span class="fal fa-spin fa-spinner fa-fw fa-4x"></span>
</div>